const coin = {};

const pearl = {
  amountPlaceholder: 'Gönderilecek miktarı girin',
};

export default {
  shippingCoin: 'Coin Gönderimi',
  level: 'LV{{num}}',
  pearl2coins: '{{pearl}}Pearl = {{coin}}Coin',
  confirmTips: 'Göndermek istediğiniz ID ve miktarı kontrol edin',
  inputAmountTips: 'Gönderilecek miktarı girin',
  resultTitle: 'Coin için',
  successTitle: 'Başarıyla gönderildi',
  successContent: 'Alıcı coinleri aldı ve sizin tarafınızdan otomatik gönderilen mesajı alacak',
  failureContent: 'Mevcut işlem anormal, lütfen işlem detaylarına giderek sonucu doğrulayın',
  pearlConfirmTips: 'Değiştirmek istediğiniz miktarı kontrol edin(Pearl Bakiye {{num}})',
  coin,
  pearl,
};
